import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BankService } from '@services/banks.service';
import { CoreModule } from 'app/modules/core.module';
import { ModalBankComponent } from '@components/managements/banks/modal-banks/modal-bank.component';
import { PanelComponent } from '@components/core-template/panel/panel.component';
import { PermissionsService } from '@services/permissions.service';

@Component({
  selector: 'app-banks',
  standalone: true,
  imports: [ModalBankComponent, PanelComponent, CoreModule],
  providers: [BankService, PermissionsService],
  templateUrl: './banks.component.html',
  styleUrls: ['./banks.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BanksComponent implements OnInit {

  private _permissionsService = inject(PermissionsService)

  public listBanks: any[] = []
  public editBank = null
  public nameBank: any
  public codeBank = null
  public newBank: FormGroup
  public listBanksTemp: any[] = []

  modalOptions = {
    size: 'xl',
    scrollable: true,
    animation: true,
    backdrop: true
  }
  closeResult = ""

  protected permissions: any
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  constructor(
    private _bankService: BankService,
    private fb: FormBuilder,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit(): void {
    this.getBanks()
    this.getPermissions()
  }

  getPermissions() {
    this._permissionsService.get("administracion-bancos").pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.permissions = res.actions
      this.cdr.markForCheck()
    })
  }

  getBanks() {
    this._bankService.getAll().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listBanks = res
      this.listBanksTemp = res
      this.cdr.markForCheck()
    })
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `${reason}`;
    });
  }

  filterBanks() {
    this.listBanks = this.listBanksTemp.filter(g => {
      const matchName = (this.nameBank || '').length === 0 || g.name.toLowerCase().includes(this.nameBank.toLowerCase())
      return matchName
    })
  }
}
